import React, { useState } from "react";
import { connect } from "react-redux";
import { NotificationsContainer } from "./style";
import Notifications from "./containers/notifications";

const Notification = ({ count }) => {
  const [notificationPanel, showNotificationPanel] = useState(false);
  return (
    <React.Fragment>
      <NotificationsContainer>
        <i
          title="اعلانات"
          className={
            (notificationPanel ? "pressed " : "") +
            "left-side-icon icon mapsa-notification"
          }
          onClick={() => showNotificationPanel(!notificationPanel)}
        />
        {parseInt(count) > 0 && (
          <div className="sidebar-badge">
            <span>{count}</span>
          </div>
        )}
        {notificationPanel && (
          <Notifications
            show={notificationPanel}
            handleShow={show => showNotificationPanel(show)}
          />
        )}
      </NotificationsContainer>
    </React.Fragment>
  );
};

const mapStateToProps = store => {
  return {
    count: store.Notification.count
  };
};

export default connect(mapStateToProps)(Notification);
